import React, {useEffect, useState} from 'react';
import { Select } from 'antd';

type props = {
    enums: any,
    enumKey: string,
    [key: string]: any,
    onlyLabel?: any
}

const SPSelectWithEnum: React.FC<props> = (props) => {
    const { enumKey, enums, onlyLabel } = props;
    const [options, setOptions] = useState<any>([]);
    // { label: item.value, value: item.key }
    useEffect(() => {
        let list = []
        list = enums?.[enumKey]?.map?.((item: any) => {
            return {
                label: item.value,
                value: onlyLabel ? item.value : item.key,
                key: item.value
            }
        })
        setOptions(list || []);
    }, [enums, onlyLabel, enumKey]);

    return  <Select {...props} options={options}/>
};

export default SPSelectWithEnum;
